import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import '../Public/css/headerdoc.scss';
import '../Public/css/headerresponsivedoc.scss';
import { Nav, Navbar, Container, NavDropdown } from 'react-bootstrap';
import CustomButton from '../Components/CustomButton';
import ModalGlobal from '../Components/ModalGlobal';
import ErrorBoundary from '../Components/ErrorBoundary';
import Login from '../Components/Login';
import ContactUsModal from '../Components/ContactUsModal';
import { withNamespaces } from 'react-i18next';
import { setToken, logOutApp, setUserCredentials } from '../../GlobalModules/Login/Actions/LoginAction';
import { selectedNavTagAction, groupTourPackageSearchData, loaderStateTrue, loaderStateFalse } from '../../Actions/AllAction';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Tooltip from 'react-bootstrap/Tooltip';
import { useParams, useHistory, useLocation } from 'react-router-dom';
const channel = new BroadcastChannel('foobar');

const checkIsHomeOrSearch = (pathStr) => {
    const cleanPath = (pathStr || '').toLowerCase().replace(/\/+$/, '');
    return cleanPath === '' ||
        cleanPath === '/' ||
        cleanPath === '/home' ||
        cleanPath.endsWith('/home') ||
        cleanPath === '/search' ||
        cleanPath.endsWith('/search');
};

if (typeof window !== 'undefined' && window.localStorage && !window.__storageClearedListenerAttached) {
    window.__storageClearedListenerAttached = true;
    const originalClear = window.localStorage.clear;
    window.localStorage.clear = function () {
        originalClear.apply(this, arguments);
        window.dispatchEvent(new CustomEvent('storageCleared'));
    };
    const originalRemoveItem = window.localStorage.removeItem;
    window.localStorage.removeItem = function (key) {
        originalRemoveItem.apply(this, arguments);
        window.dispatchEvent(new CustomEvent('storageCleared', { detail: { key } }));
    };
}

function Header(props) {
    const history = useHistory();
    const location = useLocation();
    const { type } = useParams();
    const [loginModalFlag, setLoginModalFlag] = useState(false)
    const [isLogout, setisLogout] = useState(false)
    const [showOverlay, setShowOverlay] = useState(false);
    const [contactModalOpen, setContactModalOpen] = useState(false);
    const [contactModalTitle, setContactModalTitle] = useState('Contact Us');
    const [isListPropertyModal, setIsListPropertyModal] = useState(false);

    const initialPath = typeof window !== 'undefined' ? window.location.pathname : '';
    const isInitialHomeOrSearch = checkIsHomeOrSearch(initialPath);
    if (isInitialHomeOrSearch && typeof window !== 'undefined') {
        localStorage.removeItem('selectedDestination');
        localStorage.removeItem('selectedTheme');
        localStorage.removeItem('selectedNavTag');
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.removeItem('selectedDestination');
            sessionStorage.removeItem('selectedTheme');
            sessionStorage.removeItem('selectedNavTag');
        }
    }

    const [selectedDestination, setSelectedDestination] = useState(
        () => isInitialHomeOrSearch ? '' : (localStorage.getItem('selectedDestination') || sessionStorage.getItem('selectedDestination') || '')
    );
    const [selectedTheme, setSelectedTheme] = useState(
        () => isInitialHomeOrSearch ? '' : (localStorage.getItem('selectedTheme') || sessionStorage.getItem('selectedTheme') || '')
    );
    const [selectedNavTag, setSelectedNavTag] = useState(
        () => isInitialHomeOrSearch ? '' : (localStorage.getItem('selectedNavTag') || props.selectedNavTagFromReducer || '')
    );

    useEffect(() => {
        if (props.selectedNavTagFromReducer !== undefined && props.selectedNavTagFromReducer !== selectedNavTag) {
            setSelectedNavTag(props.selectedNavTagFromReducer || '');
        }
    }, [props.selectedNavTagFromReducer]);

    useEffect(() => {
        const handleStorageClear = () => {
            const navTagInStorage = localStorage.getItem('selectedNavTag');
            if (!navTagInStorage && selectedNavTag) {
                setSelectedNavTag('');
                if (props.selectedNavTagAction) {
                    props.selectedNavTagAction('');
                }
                if (typeof sessionStorage !== 'undefined') {
                    sessionStorage.removeItem('selectedNavTag');
                }
                window.dispatchEvent(new CustomEvent('sectionSelectionChange', {
                    detail: { type: 'navTag', option: '' }
                }));
            }
            if (!localStorage.getItem('selectedDestination') && selectedDestination) {
                setSelectedDestination('');
                if (typeof sessionStorage !== 'undefined') {
                    sessionStorage.removeItem('selectedDestination');
                }
                window.dispatchEvent(new CustomEvent('sectionSelectionChange', {
                    detail: { type: 'destination', option: '' }
                }));
            }
            if (!localStorage.getItem('selectedTheme') && selectedTheme) {
                setSelectedTheme('');
                if (typeof sessionStorage !== 'undefined') {
                    sessionStorage.removeItem('selectedTheme');
                }
                window.dispatchEvent(new CustomEvent('sectionSelectionChange', {
                    detail: { type: 'theme', option: '' }
                }));
            }
        };

        const intervalId = setInterval(handleStorageClear, 300);
        window.addEventListener('storageCleared', handleStorageClear);
        window.addEventListener('storage', handleStorageClear);

        return () => {
            clearInterval(intervalId);
            window.removeEventListener('storageCleared', handleStorageClear);
            window.removeEventListener('storage', handleStorageClear);
        };
    }, [selectedNavTag, selectedDestination, selectedTheme]);

    useEffect(() => {
        const handleSelectionChange = (e) => {
            setSelectedDestination(localStorage.getItem('selectedDestination') || sessionStorage.getItem('selectedDestination') || '');
            setSelectedTheme(localStorage.getItem('selectedTheme') || sessionStorage.getItem('selectedTheme') || '');
            const navTag = e?.detail?.type === 'navTag' ? (e.detail.option || '') : (localStorage.getItem('selectedNavTag') || '');
            setSelectedNavTag(navTag);
        };
        window.addEventListener('sectionSelectionChange', handleSelectionChange);
        return () => {
            window.removeEventListener('sectionSelectionChange', handleSelectionChange);
        };
    }, []);

    useEffect(() => {
        const dest = localStorage.getItem('selectedDestination') || sessionStorage.getItem('selectedDestination') || '';
        const theme = localStorage.getItem('selectedTheme') || sessionStorage.getItem('selectedTheme') || '';
        const nav = localStorage.getItem('selectedNavTag') || sessionStorage.getItem('selectedNavTag') || '';

        const count = (dest ? 1 : 0) + (theme ? 1 : 0) + (nav ? 1 : 0);
        if (count > 1) {
            if (dest) {
                setSelectedTheme('');
                localStorage.removeItem('selectedTheme');
                if (typeof sessionStorage !== 'undefined') sessionStorage.removeItem('selectedTheme');
                setSelectedNavTag('');
                localStorage.removeItem('selectedNavTag');
                if (typeof sessionStorage !== 'undefined') sessionStorage.removeItem('selectedNavTag');
                if (props.selectedNavTagAction) props.selectedNavTagAction('');
            } else if (theme) {
                setSelectedNavTag('');
                localStorage.removeItem('selectedNavTag');
                if (typeof sessionStorage !== 'undefined') sessionStorage.removeItem('selectedNavTag');
                if (props.selectedNavTagAction) props.selectedNavTagAction('');
            }
        }
    }, []);
    const loginUserModal = () => {
        setLoginModalFlag(true)
    }
    const closeLoginUserModal = () => {
        setLoginModalFlag(false)
    }

    const loginFn = () => {
        window.scrollTo(0, 0);
        props.history.push(`/${localStorage.getItem('i18nextLng')}/login`);
    }
    const registerFn = () => {
        window.scrollTo(0, 0);
        props.history.push(`/${localStorage.getItem('i18nextLng')}/register`);
    }


    const logout = () => {
        const { logOutApp, history, setToken, setUserCredentials } = props;
        logOutApp(props.accessToken, props.token).then(() => {
            setToken("", "", "", "").then(() => {
                setUserCredentials({})

            })
            setTimeout(() => {
                setisLogout(true)
            }, 1000)
        })
    }

    useEffect(() => {
        if (isLogout) {
            let obj = {
                isLogout: isLogout,
                allTabAction: "logoutAllTab"
            }
            channel.postMessage(obj);
        }
        window.addEventListener('scroll', isSticky);
        return () => {
            window.removeEventListener('scroll', isSticky);
        };
    }, [isLogout]);

    useEffect(() => {
        const currentPath = location?.pathname || (typeof window !== 'undefined' ? window.location.pathname : '');
        if (checkIsHomeOrSearch(currentPath)) {
            setSelectedDestination('');
            localStorage.removeItem('selectedDestination');
            if (typeof sessionStorage !== 'undefined') {
                sessionStorage.removeItem('selectedDestination');
            }

            setSelectedTheme('');
            localStorage.removeItem('selectedTheme');
            if (typeof sessionStorage !== 'undefined') {
                sessionStorage.removeItem('selectedTheme');
            }

            setSelectedNavTag('');
            localStorage.removeItem('selectedNavTag');
            if (typeof sessionStorage !== 'undefined') {
                sessionStorage.removeItem('selectedNavTag');
            }
            if (props.selectedNavTagAction) {
                props.selectedNavTagAction('');
            }

            window.dispatchEvent(new CustomEvent('sectionSelectionChange', {
                detail: { type: 'all', option: '' }
            }));
            return;
        }

        const path = currentPath.toLowerCase();
        if (path.includes('destination/domestic')) {
            setSelectedDestination('Domestic');
        } else if (path.includes('destination/international')) {
            setSelectedDestination('International');
        } else if (path.includes('destination/sweet-bengal')) {
            setSelectedDestination('Sweet Bengal');
        } else if (path.includes('destination/weekend')) {
            setSelectedDestination('Weekend');
        }

        if (path.includes('theme/riding-adventure')) {
            setSelectedTheme('Riding & Adventure');
        } else if (path.includes('theme/festival')) {
            setSelectedTheme('Festival');
        } else if (path.includes('theme/historical')) {
            setSelectedTheme('Historical');
        } else if (path.includes('theme/jungle')) {
            setSelectedTheme('Jungle');
        } else if (path.includes('theme/india-offbeat')) {
            setSelectedTheme('India Offbeat');
        } else if (path.includes('theme/spiritual-theme')) {
            setSelectedTheme('Spiritual Theme');
        } else if (path.includes('theme/treck')) {
            setSelectedTheme('Trek');
        }
    }, [location?.pathname]);

    // const isSticky = (e) => {
    //     const header = document.querySelector('.bottom-header');
    //     const scrollTop = window.scrollY;
    //     scrollTop >= 250 ? header.classList.add('is-sticky') : header.classList.remove('is-sticky');
    // };
    const isSticky = (e) => {
        const header = document.querySelector('.header-inner');
        const searchPanel = document.querySelector('.searchPanel.searchPanelInner');
        const scrollTop = window.scrollY;

        if (scrollTop >= 350) {
            header?.classList.add('is-sticky');
            searchPanel?.classList.add('sticky-search');
        } else {
            header?.classList.remove('is-sticky');
            searchPanel?.classList.remove('sticky-search');
        }
    };


    const goHome = () => {
        if (props.loaderStateTrue) {
            props.loaderStateTrue();
        }

        setSelectedDestination('');
        localStorage.removeItem('selectedDestination');
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.removeItem('selectedDestination');
        }

        setSelectedTheme('');
        localStorage.removeItem('selectedTheme');
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.removeItem('selectedTheme');
        }

        setSelectedNavTag('');
        localStorage.removeItem('selectedNavTag');
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.removeItem('selectedNavTag');
        }
        if (props.selectedNavTagAction) {
            props.selectedNavTagAction('');
        }

        window.dispatchEvent(new CustomEvent('sectionSelectionChange', {
            detail: { type: 'all', option: '' }
        }));

        window.scrollTo(0, 0);
        props.history.push(`/${localStorage.getItem('i18nextLng') || 'en'}/home`);

        setTimeout(() => {
            if (props.loaderStateFalse) {
                props.loaderStateFalse();
            }
        }, 1000);
    }

    const bookingHistoryFn = () => {
        // setShowOverlay(false);
        if (props.loaderStateTrue) {
            props.loaderStateTrue();
        }
        setTimeout(() => {
            if (props.loaderStateFalse) {
                props.loaderStateFalse();
            }
            props.history.push(`/${localStorage.getItem('i18nextLng')}/booking-history`);
        }, 1000);
    }
    const FolioHistoryFn = () => {
        setShowOverlay(false);
        history.push(`/${localStorage.getItem('i18nextLng')}/folio-history`);
    }

    const creditNotesFn = () => {
        setShowOverlay(false);
        props.history.push(`/${localStorage.getItem('i18nextLng')}/credit-note`);
    }


    let user_profile_image = "";
    if (props.userCredentials && props.userCredentials.user_details && props.userCredentials.user_details.hasOwnProperty('profile_img_url')) {
        let parseObject = props.userCredentials.user_details.profile_img_url ? JSON.parse(props.userCredentials.user_details.profile_img_url) : "";
        if (parseObject != "" && parseObject.hasOwnProperty('img_url') && parseObject.img_url != "") {
            user_profile_image = parseObject.img_url
        }
    }
    let user_first_name = props.userCredentials && props.userCredentials.user_details && props.userCredentials.user_details.first_name
    let user_last_name = props.userCredentials && props.userCredentials.user_details && props.userCredentials.user_details.last_name

    const bookingConfirmation = () => {
        let bookingId = 3
        props.history.push(`/${localStorage.getItem('i18nextLng')}/payment-success/${bookingId}`);
    }


    const notfound = () => {
        props.history.push(`/${localStorage.getItem('i18nextLng')}/notfound`);
    }
    // const manageAccount = () => {
    //     setShowOverlay(false);
    //     props.history.push(`/${localStorage.getItem('i18nextLng')}/manage-account`);
    // }

    // const changePassword = () => {
    //     setShowOverlay(false);
    //     props.history.push(`/${localStorage.getItem('i18nextLng')}/change-password`);
    // }

    const handleOverlayToggle = () => {
        setShowOverlay(!showOverlay);
    };
    const handlePopoverExited = () => {
        setShowOverlay(false);
    };

    /**
     * Determines the appropriate route target dynamically based on the selected destination option
     * @param {string} option - Selected destination option (e.g. Domestic, International, Sweet Bengal, Weekend)
     * @returns {string} Route target path
     */
    const getDestinationRoute = (option) => {
        const lng = localStorage.getItem('i18nextLng') || 'en';
        const routeMap = {
            'Domestic': `/${lng}/destination/domestic`,
            'International': `/${lng}/destination/international`,
            'Sweet Bengal': `/${lng}/destination/sweet-bengal`,
            'Weekend': `/${lng}/destination/weekend`,
        };

        if (routeMap[option]) {
            return routeMap[option];
        }

        // Dynamically create a kebab-case slug for any option
        const slug = option ? option.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-') : '';
        return `/${lng}/destination/${slug}`;
    };

    /**
     * Redirects the user to the /tour-list URL with proper language prefix
     */
    const redirectToTourList = () => {
        if (props.groupTourPackageSearchData) {
            props.groupTourPackageSearchData();
        }
        const lng = localStorage.getItem('i18nextLng') || 'en';
        const tourListUrl = `/${lng}/tour-list`;
        if (history && history.push) {
            history.push(tourListUrl);
        } else if (props.history && props.history.push) {
            props.history.push(tourListUrl);
        } else {
            window.location.href = tourListUrl;
        }
    };

    /**
     * Dedicated method to handle destination selection:
     * - Mutually exclusive: clears selectedTheme and selectedNavTag
     * - Stores selectedDestination in localStorage and sessionStorage
     * - Dispatches sectionSelectionChange event
     * - Redirects user to /tour-list
     * @param {string} option - Selected destination option
     */
    const handleDestinationSelect = (option) => {
        // Clear theme
        setSelectedTheme('');
        localStorage.removeItem('selectedTheme');
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.removeItem('selectedTheme');
        }

        // Clear nav tag
        setSelectedNavTag('');
        localStorage.removeItem('selectedNavTag');
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.removeItem('selectedNavTag');
        }
        if (props.selectedNavTagAction) {
            props.selectedNavTagAction('');
        }

        // Set destination
        setSelectedDestination(option);
        localStorage.setItem('selectedDestination', option);
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.setItem('selectedDestination', option);
        }

        window.dispatchEvent(new CustomEvent('sectionSelectionChange', {
            detail: { type: 'destination', option }
        }));

        redirectToTourList();
    };

    /**
     * Removes the currently selected destination and resets state/storage
     */
    const handleRemoveDestination = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        setSelectedDestination('');
        localStorage.removeItem('selectedDestination');
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.removeItem('selectedDestination');
        }

        window.dispatchEvent(new CustomEvent('sectionSelectionChange', {
            detail: { type: 'destination', option: '' }
        }));
    };

    /**
     * Determines the appropriate route target dynamically based on the selected theme option
     * @param {string} option - Selected theme option (e.g. Riding & Adventure, Festival, Historical, etc.)
     * @returns {string} Route target path
     */
    const getThemeRoute = (option) => {
        const lng = localStorage.getItem('i18nextLng') || 'en';
        const routeMap = {
            'Riding & Adventure': `/${lng}/theme/riding-adventure`,
            'Festival': `/${lng}/theme/festival`,
            'Historical': `/${lng}/theme/historical`,
            'Jungle': `/${lng}/theme/jungle`,
            'India Offbeat': `/${lng}/theme/india-offbeat`,
            'Spiritual Theme': `/${lng}/theme/spiritual-theme`,
            'Trek': `/${lng}/theme/treck`,
        };

        if (routeMap[option]) {
            return routeMap[option];
        }

        const slug = option ? option.toLowerCase().trim().replace(/&/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') : '';
        return `/${lng}/theme/${slug}`;
    };

    /**
     * Dedicated method to handle theme selection:
     * - Mutually exclusive: clears selectedDestination and selectedNavTag
     * - Stores selectedTheme in localStorage and sessionStorage
     * - Dispatches sectionSelectionChange event
     * - Redirects user to /tour-list
     * @param {string} option - Selected theme option
     */
    const handleThemeSelect = (option) => {
        // Clear destination
        setSelectedDestination('');
        localStorage.removeItem('selectedDestination');
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.removeItem('selectedDestination');
        }

        // Clear nav tag
        setSelectedNavTag('');
        localStorage.removeItem('selectedNavTag');
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.removeItem('selectedNavTag');
        }
        if (props.selectedNavTagAction) {
            props.selectedNavTagAction('');
        }

        // Set theme
        setSelectedTheme(option);
        localStorage.setItem('selectedTheme', option);
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.setItem('selectedTheme', option);
        }

        window.dispatchEvent(new CustomEvent('sectionSelectionChange', {
            detail: { type: 'theme', option }
        }));

        redirectToTourList();
    };

    /**
     * Removes the currently selected theme and resets state/storage
     */
    const handleRemoveTheme = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        setSelectedTheme('');
        localStorage.removeItem('selectedTheme');
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.removeItem('selectedTheme');
        }

        window.dispatchEvent(new CustomEvent('sectionSelectionChange', {
            detail: { type: 'theme', option: '' }
        }));
    };

    /**
     * Dedicated method to handle nav tag selection:
     * - Mutually exclusive: clears selectedDestination and selectedTheme
     * - Stores selectedNavTag in localStorage and sessionStorage, updates Redux
     * - Dispatches sectionSelectionChange event
     * - Redirects user to /tour-list
     * @param {string} option - Tag name
     */
    const handleNavTagSelect = (option) => {
        const nextValue = selectedNavTag === option ? '' : option;

        // Clear destination
        setSelectedDestination('');
        localStorage.removeItem('selectedDestination');
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.removeItem('selectedDestination');
        }

        // Clear theme
        setSelectedTheme('');
        localStorage.removeItem('selectedTheme');
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.removeItem('selectedTheme');
        }

        // Set or remove nav tag
        setSelectedNavTag(nextValue);
        if (props.selectedNavTagAction) {
            props.selectedNavTagAction(nextValue);
        }
        if (nextValue) {
            localStorage.setItem('selectedNavTag', nextValue);
            if (typeof sessionStorage !== 'undefined') {
                sessionStorage.setItem('selectedNavTag', nextValue);
            }
        } else {
            localStorage.removeItem('selectedNavTag');
            if (typeof sessionStorage !== 'undefined') {
                sessionStorage.removeItem('selectedNavTag');
            }
        }

        window.dispatchEvent(new CustomEvent('sectionSelectionChange', {
            detail: { type: 'navTag', option: nextValue }
        }));

        if (nextValue) {
            redirectToTourList();
        }
    };

    /**
     * Removes the currently selected nav tag and resets state/storage
     */
    const handleRemoveNavTag = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        setSelectedNavTag('');
        if (props.selectedNavTagAction) {
            props.selectedNavTagAction('');
        }
        localStorage.removeItem('selectedNavTag');
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.removeItem('selectedNavTag');
        }

        window.dispatchEvent(new CustomEvent('sectionSelectionChange', {
            detail: { type: 'navTag', option: '' }
        }));
    };

    let url = window.location.href;
    let currentRouteName = url.split("/").pop();
    return (
        <div className={currentRouteName == 'home' ? "header-inner" : "header-inner"}>
            <div className='top-header'>
                <Container>
                    <div className='inn-top-header'>
                        <div className='abs-btn-panel'>
                            <CustomButton
                                onClick={() => {
                                    localStorage.removeItem('selectedDestination');
                                    localStorage.removeItem('selectedTheme');
                                    localStorage.removeItem('selectedNavTag');
                                    if (typeof sessionStorage !== 'undefined') {
                                        sessionStorage.removeItem('selectedDestination');
                                        sessionStorage.removeItem('selectedTheme');
                                        sessionStorage.removeItem('selectedNavTag');
                                    }
                                    if (props.selectedNavTagAction) {
                                        props.selectedNavTagAction('');
                                    }
                                    if (props.groupTourPackageSearchData) {
                                        props.groupTourPackageSearchData();
                                    }
                                    window.scrollTo(0, 0);
                                    history.push(`/${localStorage.getItem('i18nextLng') || 'en'}/tour-list?travel_club=1`);
                                }}
                                className="property-btn"
                                children='Travel Club'
                                type="button"
                            />
                            <CustomButton
                                onClick={() => {
                                    setContactModalTitle('Contribution');
                                    setIsListPropertyModal(false);
                                    setContactModalOpen(true);
                                }}
                                className="property-btn"
                                children='Contribution'
                                type="button"
                            />
                            {/* MICE Corporate Tours Button */}
                            <CustomButton
                                onClick={() => {
                                    setContactModalTitle('MICE Corporate Tours');
                                    setIsListPropertyModal(false);
                                    setContactModalOpen(true);
                                }}
                                className="property-btn mice-corporate-btn"
                                type="button"
                            >
                                <span>MICE Corporate Tours <sup className="mice-new-badge">NEW</sup></span>
                                
                            </CustomButton>

                            {/* <CustomButton
                                // onClick={loginFn}
                                className="property-btn"
                                children='Help'
                                type="button"
                            /> */}
                            <CustomButton
                                onClick={() => {
                                    setContactModalTitle('List your property');
                                    setIsListPropertyModal(true);
                                    setContactModalOpen(true);
                                }}
                                className="property-btn"
                                children='List your property'
                                type="button"
                            />
                            {Object.keys(props.userCredentials).length == 0 &&
                                <>
                                    <CustomButton
                                        onClick={registerFn}
                                        className="login-btn btn btn-primary"
                                        children='Register'
                                        type="button"
                                    />

                                    <CustomButton
                                        onClick={loginFn}
                                        className="login-btn btn btn-primary"
                                        children='Sign in'
                                        type="button"
                                    />
                                </>
                            }

                            {Object.keys(props.userCredentials).length > 0 &&
                                <div className='logoutBox only-desktop'>
                                    <div className='profileImg'>
                                        <OverlayTrigger placement="bottom" overlay={<Tooltip>{`${user_first_name} ${user_last_name}`}</Tooltip>}>
                                            {user_profile_image != "" ?
                                                <img className="user_icon" src={user_profile_image} /> :
                                                <img src={require('../Public/images/usericon.png')} />}
                                        </OverlayTrigger>
                                    </div>
                                    <OverlayTrigger
                                        rootClose={true}
                                        trigger="click"
                                        placement="bottom"
                                        show={showOverlay}
                                        onToggle={handleOverlayToggle}
                                        onExited={handlePopoverExited}
                                        overlay={
                                            <Popover className="group_single_action_inner group_single_action_inner_header only-desktop">
                                                <Popover.Body>
                                                    <div className="group_action_row group_action_row_header">
                                                        {currentRouteName == 'home' ? <></> :
                                                            <button className="group_action_btn_popup" onClick={() => { goHome() }}>
                                                                <span className='group_action_btn_popup_text'><span className='group_action_btn_popup_text'>Home</span></span>
                                                            </button>
                                                        }
                                                        {Object.keys(props.userCredentials).length > 0 && !props.userCredentials.user_details.is_first_time &&
                                                            <>
                                                                <button className="group_action_btn_popup" onClick={() => { bookingHistoryFn() }}>
                                                                    <span className='group_action_btn_popup_text'><span className='group_action_btn_popup_text'>Booking History</span></span>
                                                                </button>
                                                                {Object.keys(props.userCredentials).length > 0 && props.userCredentials.user_details.is_master_folio == 1 &&
                                                                    <button className="group_action_btn_popup" onClick={() => { FolioHistoryFn() }}>
                                                                        <span className='group_action_btn_popup_text'><span className='group_action_btn_popup_text'>Folio History</span></span>
                                                                    </button>
                                                                }

                                                                {/* <button className="group_action_btn_popup" onClick={() => { creditNotesFn() }}>
                                                                    <span className='group_action_btn_popup_text'><span className='group_action_btn_popup_text'>Credit Notes</span></span>
                                                                </button> */}
                                                            </>
                                                        }

                                                        {/* {Object.keys(props.userCredentials).length > 0 && !props.userCredentials.user_details.is_first_time &&
                                                                <button className="group_action_btn_popup" onClick={() => { manageAccount() }}>
                                                                    <span className='group_action_btn_popup_text'><span className='group_action_btn_popup_text'>Manage Account</span></span>
                                                                </button>} */}

                                                        {/* <button className="group_action_btn_popup" onClick={() => { changePassword() }}>
                                                                <span className='group_action_btn_popup_text'><span className='group_action_btn_popup_text'>Change Password</span></span>
                                                            </button> */}
                                                        <button className="group_action_btn_popup" onClick={() => { logout() }}>
                                                            <span className='group_action_btn_popup_text'><span className='group_action_btn_popup_text'>Log Out</span></span>
                                                        </button>
                                                    </div>
                                                </Popover.Body>
                                            </Popover>
                                        }
                                    >
                                        <button className='arrow-Down-btn'><i className="fa fa-caret-down" aria-hidden="true"></i></button>
                                    </OverlayTrigger>
                                </div>
                            }
                        </div>
                        <div class="newFooterSocial newHeaderSocial">
                            <a href="https://www.facebook.com/share/19fBwzQNh3/" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i class="fa fa-facebook" aria-hidden="true"></i></a>
                            <a href="https://www.instagram.com/thestayingcom?utm_source=qr&xtok=MXFleXM1dmNyMWE0dQ" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i class="fa fa-instagram" aria-hidden="true"></i></a>
                            {/* <a href="#" aria-label="YouTube"><i class="fa fa-youtube-play" aria-hidden="true"></i></a>
                            <a href="#" aria-label="LinkedIn"><i class="fa fa-linkedin" aria-hidden="true"></i></a> */}
                        </div>
                    </div>
                </Container>
            </div>
            {/* <div className='bottom-header'>
                <Navbar bg="primary" expand="md" className='nav_top'>
                    <Container>
                        <div className='innContainer'>
                            <Navbar.Brand href="/">
                                <div className='websiteLogoText'>
                                    <div className='websiteLogo'>
                                        <img src={require('../Public/images/stayingLogoWhite.png')} className="sidelogo" />
                                    </div>
                                </div>
                            </Navbar.Brand>
                           
                        </div>
                    </Container>
                </Navbar>
            </div> */}
            <div className='bottom-header'>
                <Navbar
                    expand="md"
                    className='nav_top'
                >
                    <Container>
                        <div className='innContainer'>

                            {/* Logo */}
                            <Navbar.Brand href="/">
                                <div className='websiteLogoText'>
                                    <div className='websiteLogo'>
                                        <img
                                            src={require('../Public/images/stayingLogoWhite.png')}
                                            className="sidelogo"
                                            alt="The Staying"
                                        />
                                    </div>
                                </div>
                            </Navbar.Brand>


                            {/* Mobile Toggle */}
                            <Navbar.Toggle
                                aria-controls="main-navbar-nav"
                                className="custom-navbar-toggle"
                            />


                            {/* Navigation */}
                            <Navbar.Collapse id="main-navbar-nav">
                                <Nav className="main-header-nav ml-auto">
                                    {/* ==================================================
                            DESTINATION
                        ================================================== */}
                                    <div className="custom-nav-item has-dropdown">

                                        <div>
                                            <button
                                                type="button"
                                                className={`custom-nav-link dropdown-trigger`}
                                                style={{
                                                    cursor: 'pointer'
                                                }}
                                            >

                                                Destination

                                                <i
                                                    className="fa fa-angle-down"
                                                    aria-hidden="true"
                                                ></i>
                                            </button>
                                        </div>


                                        <div className="header-dropdown single-dropdown">

                                            <div className="dropdown-menu-column">

                                                <a
                                                    className={`dropdown-menu-link`}
                                                    style={{
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => handleDestinationSelect('Domestic')}
                                                >
                                                    Domestic
                                                </a>
                                                <a
                                                    className={`dropdown-menu-link`}
                                                    style={{
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => handleDestinationSelect('International')}
                                                >
                                                    International
                                                </a>

                                                <a
                                                    className={`dropdown-menu-link`}
                                                    style={{
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => handleDestinationSelect('Sweet Bengal')}
                                                >
                                                    Sweet Bengal
                                                </a>
                                                <a
                                                    className={`dropdown-menu-link ${selectedDestination === 'Weekend' ? 'active selected' : ''}`}
                                                    style={{
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => handleDestinationSelect('Weekend')}
                                                >
                                                    Weekend
                                                </a>

                                            </div>

                                        </div>
                                    </div>
                                    <div className="custom-nav-item has-dropdown">

                                        <div>
                                            <button
                                                type="button"
                                                className={`custom-nav-link dropdown-trigger `}
                                                style={{
                                                    cursor: 'pointer'
                                                }}
                                            >

                                                Unique Theme

                                                <i
                                                    className="fa fa-angle-down"
                                                    aria-hidden="true"
                                                ></i>
                                            </button>
                                        </div>


                                        <div className="header-dropdown single-dropdown">

                                            <div className="dropdown-menu-column">

                                                <a
                                                    className={`dropdown-menu-link`}
                                                    style={{
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => handleThemeSelect('Riding & Adventure')}
                                                >
                                                    Riding & Adventure
                                                </a>
                                                <a
                                                    className={`dropdown-menu-link`}
                                                    style={{
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => handleThemeSelect('Festival')}
                                                >
                                                    Festival
                                                </a>

                                                <a
                                                    className={`dropdown-menu-link`}
                                                    style={{
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => handleThemeSelect('Historical')}
                                                >
                                                    Historical
                                                </a>
                                                <a
                                                    className={`dropdown-menu-link`}
                                                    style={{
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => handleThemeSelect('Jungle')}
                                                >
                                                    Jungle
                                                </a>
                                                <a
                                                    className={`dropdown-menu-link`}
                                                    style={{
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => handleThemeSelect('India Offbeat')}
                                                >
                                                    India Offbeat
                                                </a>
                                                <a
                                                    className={`dropdown-menu-link`}
                                                    style={{
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => handleThemeSelect('Spiritual Theme')}
                                                >
                                                    Spiritual Theme
                                                </a>
                                                <a
                                                    className={`dropdown-menu-link`}
                                                    style={{
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => handleThemeSelect('Trek')}
                                                >
                                                    Trek
                                                </a>

                                            </div>

                                        </div>
                                    </div>

                                    <div className="custom-nav-item">
                                        <a
                                            className={`custom-nav-link`}
                                            style={{
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => handleNavTagSelect('Curated experience')}
                                        >
                                            Curated experience
                                        </a>
                                    </div>
                                    {/* ==================================================
                            SIGNATURE TOURS
                        ================================================== */}
                                    <div className="custom-nav-item">
                                        <a
                                            className={`custom-nav-link`}
                                            style={{
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => handleNavTagSelect('Signature Tours')}
                                        >
                                            Signature Tours
                                        </a>
                                    </div>

                                    {/* ==================================================
                            PACKAGES
                        ================================================== */}
                                    <div className="custom-nav-item">
                                        <a
                                            className={`custom-nav-link`}
                                            style={{
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => handleNavTagSelect('Exclusive Collaboration')}
                                        >
                                            Exclusive Collaboration
                                        </a>

                                    </div>

                                    <div className="custom-nav-item">
                                        <a
                                            className={`custom-nav-link`}
                                            style={{
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => handleNavTagSelect('United for Travel')}
                                        >
                                            United for Travel
                                        </a>

                                    </div>





                                    {/* <div className="header-dropdown packages-dropdown">

                                            <div className="dropdown-menu-column">

                                                <a
                                                    href="/ready-itinerary-international"
                                                    className="dropdown-menu-link"
                                                >
                                                    Ready Itinerary International
                                                </a>

                                                <a
                                                    href="/ready-itinerary-domestic"
                                                    className="dropdown-menu-link"
                                                >
                                                    Ready Itinerary Domestic
                                                </a>

                                                <a
                                                    href="/customized-packages"
                                                    className="dropdown-menu-link"
                                                >
                                                    Customized Packages
                                                </a>

                                            </div>


                                            <div className="dropdown-menu-column">

                                                <a
                                                    href="/group-tour-international"
                                                    className="dropdown-menu-link"
                                                >
                                                    Group Tour International
                                                </a>

                                                <a
                                                    href="/group-tour-domestic"
                                                    className="dropdown-menu-link"
                                                >
                                                    Group Tour Domestic
                                                </a>

                                            </div>


                                            <div className="dropdown-menu-column">

                                                <a
                                                    href="/international"
                                                    className="dropdown-menu-link"
                                                >
                                                    International
                                                </a>

                                                <a
                                                    href="/domestic"
                                                    className="dropdown-menu-link"
                                                >
                                                    Domestic
                                                </a>

                                            </div>

                                        </div> */}


                                    {/* ==================================================
                            FIXED DEPARTURE
                        ================================================== */}
                                    {/* <div className="custom-nav-item has-dropdown">

                                        <button
                                            type="button"
                                            className="custom-nav-link dropdown-trigger"
                                        >
                                            Fixed Departure

                                            <i
                                                className="fa fa-angle-down"
                                                aria-hidden="true"
                                            ></i>
                                        </button>


                                        <div className="header-dropdown single-dropdown">

                                            <div className="dropdown-menu-column">

                                                <a
                                                    href="/fixed-departure/international"
                                                    className="dropdown-menu-link"
                                                >
                                                    International
                                                </a>

                                                <a
                                                    href="/fixed-departure/domestic"
                                                    className="dropdown-menu-link"
                                                >
                                                    Domestic
                                                </a>

                                            </div>

                                        </div>

                                    </div> */}





                                    {/* ==================================================
                            CURATED EXPERIENCES
                        ================================================== */}
                                    {/* <div className="custom-nav-item">

                                        <a
                                            href="/curated-experiences"
                                            className="custom-nav-link"
                                        >
                                            Curated Experiences
                                        </a>

                                    </div>



                                    <div className="custom-nav-item only-mobile">

                                        <a
                                            href=""
                                            className="custom-nav-link"
                                        >
                                            List your property
                                        </a>

                                    </div> */}
                                </Nav>

                            </Navbar.Collapse>


                        </div>
                    </Container>
                </Navbar>
                <div className='mobile-btn-grp'>
                    {Object.keys(props.userCredentials).length == 0 &&
                        <>
                            <CustomButton
                                onClick={registerFn}
                                className="login-btn btn btn-primary"
                                children='Register'
                                type="button"
                            />
                            <CustomButton
                                onClick={loginFn}
                                className="login-btn btn btn-primary"
                                children='Sign in'
                                type="button"
                            />
                        </>
                    }
                    {Object.keys(props.userCredentials).length > 0 &&
                        <div className='logoutBox only-mobile-sm'>
                            <div className='profileImg'>
                                <OverlayTrigger placement="bottom" overlay={<Tooltip>{`${user_first_name} ${user_last_name}`}</Tooltip>}>
                                    {user_profile_image != "" ?
                                        <img className="user_icon" src={user_profile_image} /> :
                                        <img src={require('../Public/images/usericon.png')} />}
                                </OverlayTrigger>
                            </div>
                            <OverlayTrigger
                                rootClose={true}
                                trigger="click"
                                placement="bottom"
                                show={showOverlay}
                                onToggle={handleOverlayToggle}
                                onExited={handlePopoverExited}
                                overlay={
                                    <Popover className="group_single_action_inner group_single_action_inner_header only-mobile-sm">
                                        <Popover.Body>
                                            <div className="group_action_row group_action_row_header">
                                                {currentRouteName == 'home' ? <></> :
                                                    <button className="group_action_btn_popup" onClick={() => { goHome() }}>
                                                        <span className='group_action_btn_popup_text'><span className='group_action_btn_popup_text'>Home</span></span>
                                                    </button>
                                                }
                                                {Object.keys(props.userCredentials).length > 0 && !props.userCredentials.user_details.is_first_time &&
                                                    <>
                                                        <button className="group_action_btn_popup" onClick={() => { bookingHistoryFn() }}>
                                                            <span className='group_action_btn_popup_text'><span className='group_action_btn_popup_text'>Booking History</span></span>
                                                        </button>
                                                        {Object.keys(props.userCredentials).length > 0 && props.userCredentials.user_details.is_master_folio == 1 &&
                                                            <button className="group_action_btn_popup" onClick={() => { FolioHistoryFn() }}>
                                                                <span className='group_action_btn_popup_text'><span className='group_action_btn_popup_text'>Folio History</span></span>
                                                            </button>
                                                        }

                                                        {/* <button className="group_action_btn_popup" onClick={() => { creditNotesFn() }}>
                                                                    <span className='group_action_btn_popup_text'><span className='group_action_btn_popup_text'>Credit Notes</span></span>
                                                                </button> */}
                                                    </>
                                                }

                                                {/* {Object.keys(props.userCredentials).length > 0 && !props.userCredentials.user_details.is_first_time &&
                                                                <button className="group_action_btn_popup" onClick={() => { manageAccount() }}>
                                                                    <span className='group_action_btn_popup_text'><span className='group_action_btn_popup_text'>Manage Account</span></span>
                                                                </button>} */}

                                                {/* <button className="group_action_btn_popup" onClick={() => { changePassword() }}>
                                                                <span className='group_action_btn_popup_text'><span className='group_action_btn_popup_text'>Change Password</span></span>
                                                            </button> */}
                                                <button className="group_action_btn_popup" onClick={() => { logout() }}>
                                                    <span className='group_action_btn_popup_text'><span className='group_action_btn_popup_text'>Log Out</span></span>
                                                </button>
                                            </div>
                                        </Popover.Body>
                                    </Popover>
                                }
                            >
                                <button className='arrow-Down-btn'><i className="fa fa-caret-down" aria-hidden="true"></i></button>
                            </OverlayTrigger>
                        </div>
                    }
                </div>
            </div>
            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={loginModalFlag}
                    onHide={closeLoginUserModal}
                    title="Sign in"
                    className="modalcustomize mondimension loginModal"
                    footer={false}
                    closeButton={true}
                    saveButtonLabel="Confirm"
                    saveButtonClassName="btn btn-primary savebtn"
                    cancelShow={true}
                    body={
                        <>
                            <ErrorBoundary title="BookRoomModalContent Error">
                                <Login
                                    history={props.history}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>
            <ContactUsModal
                show={contactModalOpen}
                onHide={() => {
                    setContactModalOpen(false);
                    setIsListPropertyModal(false);
                }}
                title={contactModalTitle}
                showListPropertyCheckbox={isListPropertyModal}
            />
        </div>
    );
}


const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token,
        selectedNavTagFromReducer: globalState.mainReducerData?.selectedNavTag,
    };
}
export default connect(mapStateToProps, { setUserCredentials, logOutApp, setToken, selectedNavTagAction, groupTourPackageSearchData, loaderStateTrue, loaderStateFalse })(withNamespaces()(Header));
